import { isAndroid } from "@memorang/helpers/platform";
import { Appbar, Text } from "react-native-paper";
import Box from "../../Box";
import StudySessionProgressbar from "../StudySessionProgressbar/StudySessionProgressbar";

type Props = {
	hasParentStem?: boolean;
	handleClickRightCta: () => void;
	isAnswered?: boolean;
	currentProgress: number;
	isReportPage?: boolean;
	reviewTitleOverride?: string;
};

const FormativeStudySessionAppbar = ({
	hasParentStem,
	handleClickRightCta,
	isAnswered,
	currentProgress,
	isReportPage,
	reviewTitleOverride,
}: Props) => {
	return (
		<Appbar.Header
			mode="small"
			style={{
				justifyContent: "center",
				paddingTop: isAndroid ? 8 : 0,
				height: reviewTitleOverride ? 100 : 80,
			}}
		>
			<Box
				position="relative"
				width="100%"
				maxWidth={hasParentStem ? 1300 : 840}
			>
				{reviewTitleOverride && (
					<Box
						position="absolute"
						top={0}
						left={0}
						right={0}
						alignItems="center"
					>
						<Text variant="labelMedium">{reviewTitleOverride}</Text>
					</Box>
				)}
				<Box flex={1}>
					<StudySessionProgressbar
						showClose
						handleSelectClose={handleClickRightCta}
						isAnswered={isAnswered}
						currentProgress={currentProgress}
						isReportPage={isReportPage}
					/>
				</Box>
			</Box>
		</Appbar.Header>
	);
};

export default FormativeStudySessionAppbar;
